<template>
  <ul v-if="breadcrumbs.length > 1" class="flex space-x-1 text-sm">
    <li v-for="(item, index) in breadcrumbs" :key="index">
      <NuxtLink
        :to="item.url"
        class="font-medium text-gray-200"
        :class="{
          '!font-bold !text-black': index === page.breadcrumbs.length - 2,
        }"
      >
        {{ item.title }}
        <!-- eslint-disable-next-line -->
        <template v-if="index !== page.breadcrumbs.length - 2">|</template>
      </NuxtLink>
    </li>
  </ul>
</template>

<script lang="ts" setup>
const props = defineProps({
  page: {
    type: Object,
    required: true,
  },
})

const breadcrumbs = computed(() => {
  // remove first breadcrumb
  return props.page.breadcrumbs.slice(1)
})
</script>
